<script setup lang="ts">
defineProps<{ header: string, name: string }>()
</script>

<template>
  <TheDataCard class="h-fit">
    <n-collapse-item :name>
      <template #header>
        <h1>{{ header }}</h1>
      </template>
      <template #header-extra>
        <slot name="header-extra" />
      </template>
      <slot name="controls" />
      <slot />
    </n-collapse-item>
  </TheDataCard>
</template>

<style scoped>
h1 {
  @apply text-xl font-semibold mb-2
}
</style>
